import { mediaConstants } from '../constants';

export function media(state = {}, action) {
  switch (action.type) {
    case mediaConstants.GETALL_REQUEST:
      return {
        state,
        loading: false
      }
    case mediaConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        info: action.info,
        loading: false
      }
    case mediaConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: action.loadingStatus
      }
    case mediaConstants.GETALL_LOADING:
      return {
        ...state,
        loading: true
      }
    default:
      return state;
  }
}

export function mediaUpload(state = {}, action) {
  switch (action.type) {
    case mediaConstants.UPLOAD_REQUEST:
      return {
        state,
        loading: false
      }
    case mediaConstants.UPLOAD_SUCCESS:
      return {
        ...state,
        callbackFileIndex: action.callbackFileIndex,
        loading: false
      }
    case mediaConstants.UPLOAD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: action.loadingStatus
      }
    case mediaConstants.UPLOAD_PROCESSING:
      return {
        ...state,
        loading: true
      }
    default:
      return state;
  }
}

export function mediaDelete(state = {}, action) {
  switch (action.type) {
    case mediaConstants.DELETE_REQUEST:
      return {
        state,
        loading: false
      }
    case mediaConstants.DELETE_SUCCESS:
      return {
        ...state,
        deleteCallback: action.deleteCallback,
        loading: false
      }
    case mediaConstants.DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: action.loadingStatus
      }
    case mediaConstants.DELETE_PROCESSING:
      return {
        ...state,
        loading: true
      }
    default:
      return state;
  }
}

